import dynamic from 'next/dynamic';
import { FC } from 'react';

export const exportDynamic = (component: FC<any>) => {
    return dynamic(() => Promise.resolve(component), { ssr: false });
};
